import React from 'react';
import { Form, Field } from 'react-final-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap';
import Select from 'react-select';

import { required, number, positiveNumber } from '../../../forms';

export const renderBootstrapField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    { label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
    />
  </InputGroup>
);

const renderNoteField = ({ input, label, type, placeholder, meta: { active, touched, error, warning } }) => (
  <FormGroup>
    <ControlLabel>{label}</ControlLabel>
    <FormControl
      {...input}
      componentClass="textarea"
      name="note"
      placeholder={placeholder}
    />
  </FormGroup>
);
// handleBrandChange(brands) {
//   const brandIds = brands.map(brand => brand.value);
//   this.setState({
//     brands: brandIds,
//     save: true,
//   });
// }

const RenderSelectInput = ({input, options, name, id, label, help, meta: { active, touched, error, warning }}) => (
  <FormGroup>
    <ControlLabel>{label}</ControlLabel>
    <Select
      id={id}
      name={name}
      options={options}
      value={input.value}
      onChange={(value) => {
        const values = value.map(v => v.value);
        input.onChange(values);
      }}
      onBlur={(value) => input.onBlur(value.value)}
      multi
      joinValues
    />
    {(help && <HelpBlock>{help}</HelpBlock>)}
    {touched &&
      ((error && <p className="alert alert-danger">{error}</p>) ||
        (warning && <p className="alert alert-warning">{warning}</p>))}
  </FormGroup>
);


const BidUpdateForm = ({ onSubmit, initialValues, options }) => (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      validate={(values) => {
        const errors = {};
        if (!values.note) {
          errors.note = 'A message is required.';
        }
        if (!values.bids) {
          errors.FORM_ERROR = 'At least one hotel must be selected.';
        }
        return errors;
      }}
      render={({ handleSubmit, reset, submitting, pristine, errors }) => (
        <form onSubmit={handleSubmit} >
          <div className="col-sm-9">
            <FormGroup>
              <Field
                name="note"
                type="textarea"
                component={renderNoteField}
                label="Message"
                placeholder="This note be sent to all the selected bid requests."
              />
            </FormGroup>
            <FormGroup>
              <Field
                name="bids"
                component={RenderSelectInput}
                options={options}
              />
            </FormGroup>
          </div>
          <div className="col-sm-9">
            { errors.FORM_ERROR && (
              <p className="alert alert-danger">{errors.FORM_ERROR}</p>
            )}
            { errors.note && (
              <p className="alert alert-danger">{errors.note}</p>
            )}
            <FormGroup>
              <ButtonToolbar>
                <Button
                  disabled={pristine || submitting}
                  bsStyle="success"
                  type="submit"
                >
                  <i className="fa fa-envelope fa-lg" /> Send
                </Button>
              </ButtonToolbar>
            </FormGroup>
          </div>
        </form>
      )}
    />
  );

export default BidUpdateForm;



// WEBPACK FOOTER //
// src/routes/tours/components/BidUpdateForm.js